import { createSlice } from "@reduxjs/toolkit";

import { connectWebRTCStatuses, disconnectWebRTCStatuses, startWebRTCSessionStatuses } from "../effects/webrtc-effects";

const initialState = {
  isConnected: false,
  loading: false,
  peers: {},
  streams: {},
};

const WebRTCSlice = createSlice({
  name: "webrtc",
  initialState,
  reducers: {
    setStream: (state, action) => {
      const stream = action.payload.stream;
      const cameraId = action.payload.cameraId;
      stream.cameraId = cameraId;
      state.peers[cameraId].stream = stream;
      state.streams[cameraId] = stream;
    },
    resetWebRTC: () => initialState,
  },
  extraReducers: {
    ...connectWebRTCStatuses,
    ...disconnectWebRTCStatuses,
    ...startWebRTCSessionStatuses,
  },
});

const { actions, reducer } = WebRTCSlice;

export const { setStream, resetWebRTC } = actions;

export default reducer;
